export default __webpack_public_path__ + "static/media/sidenav-embelishment.6b8b50f7.svg";